import { Component, OnInit } from '@angular/core';
import {ActivatedRoute,Router} from '@angular/router';
import {HttpClient,HttpParams,HttpEventType,HttpResponse,HttpRequest,HttpHeaders} from '@angular/common/http';
import { environment as configs } from 'src/environments/environment';
declare var Swal;
@Component({
  selector: 'app-integrate-psp',
  templateUrl: './integrate-psp.component.html',
  styleUrls: ['./integrate-psp.component.css']
})
export class IntegratePspComponent implements OnInit {

   host=configs['ApiHost'];
  constructor(private actRoute:ActivatedRoute,private httpClient:HttpClient,private router:Router) { }

  ngOnInit() {
    this.actRoute.params.subscribe(resp=>{
       // console.log(resp.id)
      this.httpClient.get(this.host+'/integrate/rec/'+resp.id,{headers:new HttpHeaders({'Access-Control-Allow-Credentials':'true'}), withCredentials:true}).subscribe(resp=>{
         // console.log('asdfas dasdf asdf',resp)

      
        if(resp['status']==true){
          localStorage.removeItem('SKDST')
          /* let Roles={
            ""
          } */

          let user={'role':resp['role'],
                    'username':resp['username'],
                    'branch':resp['branch'],
          }
          if(resp['ELRole']){
            user['ELRole']=resp['ELRole'];
          }

          if(resp['CircleName']){
            user['CircleName']=resp['CircleName'];
          }

          localStorage.setItem('auth-token',resp['token']);
          localStorage.setItem('user',JSON.stringify(user));



          // console.log(user['role'].toString())

          /* --------------REdirection ------------- */
            if(user['role'].toString()=='1017' || user['ELRole']=='BACO'){   
              this.router.navigate(['inspector','dashboard']);
            }
            else if(user['role'].toString()=='1022' || user['ELRole']=='ADDF'){   
              this.router.navigate(['/worker/register'])
            }
            else if(user['role'].toString()=='1023' || user['ELRole']=='DDRF'){   
              this.router.navigate(['/worker/register'])
            }
            
            else if(user['role'].toString()=='sewakendra'){

              localStorage.setItem('SKDST',resp['distt'])

              let subServiceCode=resp['subservice']
              

              switch(subServiceCode) {
                  case '306':  this.router.navigate(['/worker/register']); break;
                  case '331':  //this.serviceUnavailable();
                  this.router.navigate(['/worker/scheme-view-forms'], { queryParams: { id: "34" } });
                        break;
                  case '332':  //this.serviceUnavailable();
                        this.router.navigate(['/worker/scheme-view-forms'],{queryParams:{id:'35'}});
                        break;
                  case '337':  //this.serviceUnavailable();
                        this.router.navigate(['/worker/scheme-view-forms'],{queryParams:{id:'36'}});
                        break;
                  case '334':  //this.serviceUnavailable();
                        this.router.navigate(['/worker/scheme-view-forms'],{queryParams:{id:'37'}});
                        break;
                  case '333':  //this.serviceUnavailable();
                        this.router.navigate(['/worker/scheme-view-forms'],{queryParams:{id:'38'}});
                        break;
                  case '340':  //this.serviceUnavailable();
                        this.router.navigate(['/worker/scheme-view-forms'],{queryParams:{id:'39'}});
                        break;
                  case '339':  //this.serviceUnavailable();
                        this.router.navigate(['/worker/scheme-view-forms'],{queryParams:{id:'40'}});
                        break;
                  case '336':  //this.serviceUnavailable();
                        this.router.navigate(['/worker/scheme-view-forms'],{queryParams:{id:'41'}});
                        break;
                  case '352':  //this.serviceUnavailable();338
                        this.router.navigate(['/worker/scheme-view-forms'],{queryParams:{id:'42'}});
                        break;
                  // case '352':  //this.serviceUnavailable();
                  //       this.router.navigate(['/worker/scheme-view-forms'],{queryParams:{id:'43'}});
                  //       break;
                  // case '341':  //this.serviceUnavailable();
                  //       this.router.navigate(['/worker/scheme-view-forms'],{queryParams:{id:'44'}});
                  //       break;
                  case '349':  //this.serviceUnavailable();
                  this.router.navigate(['/worker/scheme-view-forms'],{queryParams:{id:'45'}});
                  break;


                  //case '343':  this.router.navigate(['/worker/scheme-view-forms'],{queryParams:{id:'45'}}); break;
                  case '343':  //this.serviceUnavailable();
                        this.router.navigate(['/worker/scheme-view-forms'],{queryParams:{id:'46'}});
                        break;
                  case '344':  //this.serviceUnavailable();
                        this.router.navigate(['/worker/scheme-view-forms'],{queryParams:{id:'47'}});
                        break;
                  case '345':  //this.serviceUnavailable();
                        this.router.navigate(['/worker/scheme-view-forms'],{queryParams:{id:'48'}});
                        break;
                  case '346':  //this.serviceUnavailable();
                        this.router.navigate(['/worker/scheme-view-forms'],{queryParams:{id:'49'}});
                        break;
                  // case '351':  //this.serviceUnavailable();
                  //       this.router.navigate(['/worker/scheme-view-forms'],{queryParams:{id:'50'}});
                  //       break;
                  // case '351':  //this.serviceUnavailable();
                  //       this.router.navigate(['/worker/scheme-view-forms'],{queryParams:{id:'52'}});
                  //       break;
                  case '351':  //this.serviceUnavailable();
                  this.router.navigate(['/worker/scheme-view-forms'],{queryParams:{id:'55'}});
                  break;
                  case '1454':  //this.serviceUnavailable();
                  this.router.navigate(['/worker/scheme-view-forms'],{queryParams:{id:'54'}});
                  break;
                  case '1455':  //this.serviceUnavailable();
                  this.router.navigate(['/worker/scheme-view-forms'],{queryParams:{id:'56'}});
                  break;
                 
      


                  case '359':  this.router.navigate(['/worker/ammendment']); break;
                  //case '1047':  this.router.navigate(['/worker/ammendment']); break;
                  case '353':  this.router.navigate(['/worker/renew']); break;

                  //case '359':  this.router.navigate(['worker','register']); break;
                  // Scheme Objection Resolve
                  case '1029': this.router.navigate(['worker','details']); break;

                  case '1030': this.router.navigate(['worker','schemedetails']); break;
                  case '1031': this.router.navigate(['worker','schemedetails']); break;
                  case '1032': this.router.navigate(['worker','schemedetails']); break;
                  case '1033': this.router.navigate(['worker','schemedetails']); break;
                  case '1034': this.router.navigate(['worker','schemedetails']); break;
                  case '1035': this.router.navigate(['worker','schemedetails']); break;
                  case '1036': this.router.navigate(['worker','schemedetails']); break;
                  case '1037': this.router.navigate(['worker','schemedetails']); break;
                  case '1038': this.router.navigate(['worker','schemedetails']); break;
                  case '1039': this.router.navigate(['worker','schemedetails']); break;
                  case '1040': this.router.navigate(['worker','schemedetails']); break;
                  case '1041': this.router.navigate(['worker','schemedetails']); break;
                  case '1042': this.router.navigate(['worker','schemedetails']); break;
                  case '1043': this.router.navigate(['worker','schemedetails']); break;
                  case '1044': this.router.navigate(['worker','schemedetails']); break;
                  case '1045': this.router.navigate(['worker','schemedetails']); break;
                  case '1046': this.router.navigate(['worker','schemedetails']); break;
                  case '1456': this.router.navigate(['worker','schemedetails']); break;
                  case '1457': this.router.navigate(['worker','schemedetails']); break;
                  case '1047': this.router.navigate(['worker','details']); break;

                  
                  case '1080': this.router.navigate(['worker','card',resp['cuid']]); break;

                  case '1313': this.router.navigate(['worker', 'covid']); break;

                  case '1314': this.router.navigate(['worker', 'worker-fees']); break;

                   default:  this.router.navigate(['login']); break;
              }



            }else if(user['role'].toString()=='1004' || user['ELRole']=='LBIN'){
              this.router.navigate(['inspector','dashboard']);
            }else if(user['role'].toString()=='1005' || user['ELRole']=='LCRK'){
              this.router.navigate(['inspector','dashboard']);
            }
            else if(user['role'].toString()=='1001' || user['ELRole']=='BADM'){
              this.router.navigate(['inspector','dashboard']);
            }
            else if (user['role'].toString() == '1009' || user['ELRole'] == 'BWDH') {
              this.router.navigate(['inspector', 'dashboard']);
            }
            else if(user['ELRole']=='DPSC' || user['ELRole']=='ALCR' || user['ELRole']=='BDLC'){
              this.router.navigate(['inspector','dashboard']);
            }
            else if(user['role'].toString()=='1060' || user['ELRole']=='LBCA'){
              this.router.navigate(['inspector','update-account']);
            }
            else{
              this.router.navigate(['login']);
            }
           /* -------------------------------------- */

        }else{
          this.router.navigate(['login'])
        }

      })

    })
  }


  serviceUnavailable(){
   
     let timerInterval;

    Swal.fire({
    type:'info',
      title: 'Service Unavailable',
      html: 'This service is temporarily unavailable.<br>you will be redirect back to esewa in <strong></strong> seconds.',
      timer: 6000,
      onBeforeOpen: () => {
        Swal.showLoading()
        timerInterval = setInterval(() => {
          Swal.getContent().querySelector('strong')
            .textContent = Swal.getTimerLeft()/1000;
        }, 100)
      },
      onClose: () => {
        clearInterval(timerInterval)
         window.location.href="https://esewa.punjab.gov.in/";
      }
    }).then((result) => {
      if (
        result.dismiss === Swal.DismissReason.timer
      ) {
       window.location.href="https://esewa.punjab.gov.in/";

      }
    })

     
  }

}
